import { Component, OnInit } from '@angular/core';
import { MasterService,AttendanceService,AppraisalService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-asesstaf',
  templateUrl: './asesstaf.component.html',
  styleUrls: ['./asesstaf.component.scss'],
  providers:[MasterService,AttendanceService,AppraisalService]
})
export class AsesstafComponent implements OnInit {

   sections:any=[];
         classes:any=[];
         fmodel:any={};
         attdata:any=[];
         arrcourse:any=[];
         arrstaff:any=[];
         oprtype:any='';
         tabledata: any = {};
         strattmarked="";
         showload:any="no";
         showsms:any="no";
         arrrws=[{name:'Read'},{name:'Write'},{name:'Speak'},{name:'Read,Write'},{name:'Read,Speak'},{name:'Write,Speak'},{name:'Read,Write,Speak'}];
         dropdownSettings:IDropdownSettings = {singleSelection: false,
           idField: 'name',
           textField: 'name',
          //  selectAllText: 'Select All',
          //  unSelectAllText: 'UnSelect All',
           itemsShowLimit: 0,
          //  allowSearchFilter: true
          };
        arrrating=[{id:1,val:'1'},{id:2,val:'2'},{id:3,val:'3'},{id:4,val:'4'},{id:5,val:'5'}];
         closeResult: string;
         modalOptions:NgbModalOptions;
         smmodalOptions:NgbModalOptions;
         private modalRef: NgbModalRef;
         private smallmodalRef: NgbModalRef;
       arrquestions: any;
  arrasses: any;
  objclass: any;
         constructor(private http: HttpClient,private apservice:AppraisalService,private aservice:AttendanceService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
       
         ngOnInit(): void {
           this.selaprasses("sstaf");
           //this.massection();
           this.fmodel.attdt=this.mservice.getdatetoday();
         }
       
            setfeedback(j,k,l,m,val)
       {
    debugger
       // alert(j);
       this.arrquestions[j].group2[k].group3[l].questions[m].aprqtres=val;
       console.log('clicked',this.arrquestions);
    
       }
     
         getstaff() {
           this.mservice.staffrolewise()
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   //resultArray.unshift({emid:"0",emnm:"ALL"});
                //  resultArray.shift();
                   this.arrstaff = resultArray;
                  
                   this.fmodel.emid=resultArray[0].emid;
                   // this.amodel.emid=resultArray[0].emid;
                   // this.SelectAttdcorDetails();
                   this.getquestions(2,1,this.fmodel.emid);
               },
               error => console.log("Error :: " + error)
               )
         }
     
     
          getquestions(fmid,stepid,emid) {
           this.apservice.selapprhrtaprd(fmid,stepid,emid)
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   
                   this.arrquestions = resultArray;
                  
                   
               },
               error => console.log("Error :: " + error)
               )
         }
     
          selaprasses(tag) {
           this.apservice.selaprasses(tag)
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   
                   this.arrasses = resultArray;
                  
                   
               },
               error => console.log("Error :: " + error)
               )
         }
     
       
            openclass(content,objdata) {
      
         this.objclass=objdata;
        this.getquestions(objdata.aprfmid,2,objdata.emid);
       
       this.modalOptions = {
         backdrop:'static',
         backdropClass:'customBackdrop',
         size:'lg'
        
        
       }
       this.modalRef=this.modalService.open(content,this.modalOptions);
       
       this.modalRef.result.then((result) => {
      
            
         }, (reason) => {
             
         });
     }
     
        
       
         masclass() {
           this.mservice.masclass()
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   this.classes = resultArray;
                   this.fmodel.clid=resultArray[0].clid;
                   //this.fmodel1.clid=resultArray[0].clid;
                   this.massection();
                 //  this.masperiod();
                  // this.mascourse();
                  
               },
               error => console.log("Error :: " + error)
               )
         }
       
        
       
         mascourse() {
           this.mservice.mascourse()
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   this.arrcourse = resultArray;
                   this.fmodel.crid=resultArray[0].crid;
                   this.masclass();
                   //this.fmodel1.crid=resultArray[0].crid;
               },
               error => console.log("Error :: " + error)
               )
         }
       
         // massection() {
         //   this.mservice.massection()
         //       .subscribe(
         //       resultArray => {
         //           console.log('getdashcounts', resultArray);
         //           this.sections = resultArray;
         //           this.fmodel.secid=resultArray[0].scid;
         //       },
         //       error => console.log("Error :: " + error)
         //       )
         // }
       
         massection() {
           this.mservice.massection()
               .subscribe(
               resultArray => {
                   console.log('getdashcounts', resultArray);
                   this.sections = resultArray;
                   this.fmodel.secid=resultArray[0].scid;
                  // this.SelectAttdDetails();
                 //  this.getevlrooms();
                   // this.fmodel1.scid=resultArray[0].scid;
                   // this.subjects(this.fmodel.clid,this.fmodel.crid);
               },
               error => console.log("Error :: " + error)
               )
         }
       
         printqrlabelsbulk(obj){
           debugger;
             var clcd=localStorage.getItem('clcd');
             var aycd=localStorage.getItem('aycd');
              var url=this.aservice.callurl+"qrcode/2Upevlstubar.php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
              window.open(url,'','_blank');
            }
       
            openqrdl(content)
       {
         // this.objqrprint.bkid=bkid;
         // this.objqrprint.nobc=1;
         this.fmodel.qrdoctype='2Upevlstubar';
       
       
         this.modalRef=this.modalService.open(content,this.smmodalOptions);
         
         this.modalRef.result.then((result) => {
        
              // this.Asmtdetls(asid);
               this.closeResult = `Closed with: ${result}`;
           }, (reason) => {
               // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
           });
       }
       
            printqrlabels(obj){
             debugger;
               var clcd=localStorage.getItem('clcd');
               var aycd=localStorage.getItem('aycd');
                var url=this.aservice.callurl+"qrcode/"+obj.qrdoctype+".php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
                window.open(url,'','');
              }
         
            expbarlist(obj){
             debugger;
               var clcd=localStorage.getItem('clcd');
               var aycd=localStorage.getItem('aycd');
                var url=this.aservice.callurl+"export/expcsv_roomallot.php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
                window.open(url,'');
              }
           
         SelectAttdDetails() {
           debugger
           var clid = this.fmodel.clid;
           var crid = this.fmodel.crid;
           var secid = this.fmodel.secid;
           var rmid = this.fmodel.rmid;
           let clcd=localStorage.getItem('clcd');
           let aycd=localStorage.getItem('aycd');
           
           var asgnmtdata = { clid: clid, clcd:clcd,aycd:aycd,crid:crid,rmid:rmid };
           console.log('model-by', asgnmtdata);
           this.aservice.getroomallocationdata(asgnmtdata)
               .subscribe(resultArray => {
                   console.log('ret-by-atd', resultArray);
       //alert(resultArray.length);
                
                  resultArray.forEach(x => x.status = x.status === 'true');
                  this.attdata=resultArray;
               }, error =>
                   alert('error in connection')
               );
       }
       
       // Savedetails()
       // {
       
       //   console.log('savearr',this.attdata);
       // }
       
       
       
       SelectAttdDtlsifnotavail() {
           debugger
           var clid = this.fmodel.clid;
           var crid = this.fmodel.crid;
           var secid = this.fmodel.secid;
           var attdt = this.fmodel.attdt;
           let clcd=localStorage.getItem('clcd');
           let aycd=localStorage.getItem('aycd');
           
           var asgnmtdata = { clid: clid, secid: secid, attdt: attdt,oprtype:'selstuses',clcd:clcd,aycd:aycd,crid:crid};
           console.log('model-by', asgnmtdata);
           this.aservice.by_sp_clmattendance(asgnmtdata)
               .subscribe(resultArray => {
                   console.log('ret-by-atd', resultArray);
                   this.attdata = resultArray;
       
                   //alert(resultArray.message);
       
               }, error =>
                   alert('error in connection')
               );
       }
       
       
       saveappraisal()
       {
     var feedarr=[];
     var tag=true
         outerloop:for(let j=0;j<this.arrquestions.length;j++)
           {
     
             for (let k=0;k<this.arrquestions[j].group2.length;k++)
             {
               for(let l=0;l<this.arrquestions[j].group2[k].group3.length;l++)
               {
             for(let i=0;i<this.arrquestions[j].group2[k].group3[l].questions.length;i++)
             {
             let objitm:any={};
             if(this.arrquestions[j].group2[k].group3[l].questions[i].aprqtres.trim() == "")
             {
               alert('Please fill all the details');
               tag=false;
               break outerloop;
             }
               objitm.aprqtid=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid;
             objitm.residh=this.arrquestions[j].group2[k].group3[l].questions[i].residh;
             objitm.residd=this.arrquestions[j].group2[k].group3[l].questions[i].residd;
             objitm.aprqtres=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtres.trim();
             objitm.aprqtrmk1=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtrmk1.trim();
             objitm.aprqtrmk2=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtrmk2.trim();
             console.log('objitm',objitm);
             feedarr.push(objitm);
             
             }
           }
           }
           }
     
           if(tag)
           { 
           var pst={step:2,emid:"",loopdata:feedarr};
      
       this.apservice.saveappraisal(pst)
             .subscribe(
             result => {
                 console.log('SavegenmasDetails', result);
                 //this.suppliers = resultArray;
                 alert(result.message);
                 if(result.status=='success')
                 {
                   
                 this.SelectAttdDetails();
                 }
                else
                {
       
                }
             },
             error =>{ alert('Error While saving...');}
             )
       
       console.log('data',feedarr);
       }
     }
       }
       
     